export default "__VITE_ASSET__CflhAz93__"